import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Header, Footer } from "@/components/SiteChrome";
import { ProductTile } from "@/components/ProductTile";
import api from "@/lib/api";

export default function Wishlist() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        api.get("/wishlist").then(({ data }) => setItems(data.items)).finally(() => setLoading(false));
    }, []);

    return (
        <div className="min-h-screen bg-[hsl(var(--dust-50))]" data-testid="wishlist-page">
            <Header />
            <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
                <div className="font-mono-brand text-xs uppercase tracking-[0.25em] text-[hsl(var(--ink-soft))]">Saved</div>
                <h1 className="mt-3 font-display text-5xl uppercase italic text-[hsl(var(--ink))]">Wishlist.</h1>
                {loading ? null : items.length === 0 ? (
                    <div className="mt-12 border-2 border-dashed border-[hsl(var(--dust-300))] p-12 text-center">
                        <div className="font-display text-3xl uppercase italic text-[hsl(var(--ink))]">Nothing saved yet.</div>
                        <Link to="/shop" className="mt-6 inline-block btn-primary">Find some gear →</Link>
                    </div>
                ) : (
                    <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                        {items.map((p) => <ProductTile key={p.slug} p={p} />)}
                    </div>
                )}
            </div>
            <Footer />
        </div>
    );
}
